function formatStatus(value) {
    switch (value) {
        case 'I':
            return 'Invited';
        case 'A':
            return 'Accepted';
        case 'B':
            return 'Rejected (Post EX6)';
        case 'F':
            return 'Rejected';
        default:
            return '';
    }
}

export { formatStatus };